<template>
    <v-container class="grey lighten-5 title-bar">
      <v-row>
        <v-col cols="8">
          <p class="title-bar__title display-1">{{ title }}</p>
          <p>{{ intro }}</p>
        </v-col>
        <v-col v-if="actions" class="text-right">
          <v-btn v-for="action in actions" :key="action.name"
            :outlined="action.color ? false : true"
            @click="redirect(action.to)"
            :title="action.name"
            :color="action.color || ''"
            class="ml-4"
            :active="false"
            >
            <v-icon v-if="action.icon" left small>{{ action.icon }}</v-icon>{{ action.name }}
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="mt-4"/>
    </v-container>
</template>
<script>
export default {
  name: 'title-bar',
  props: {
    actions: {
      type: Array,
      required: false,
    },
  },
  methods: {
    redirect (to) {
      // using manual redirect as inline :to is causing active styling issues
      this.$router.push(to)
    },
  },
  computed: {
    intro () {
      return (this.$route.meta.introI18NKey) ? this.$t(this.$route.meta.introI18NKey) : this.$route.meta.intro
    },
    title () {
      return (this.$route.meta.titleI18NKey) ? this.$t(this.$route.meta.titleI18NKey) : this.$route.meta.title
    },
  },
}
</script>
<style lang="scss" scoped>
.user-guides-link {
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
</style>
